import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { checkAccount } from '../../../../actions/';
import { selectBupaChecked, selectfortisBCAccountAccountNumber, selectBupaVerifyErrorMsg } from '../../../../selectors/CustomerDetails';
//Components
import TextBox from '../../../Basic/TextBox';
import LinkButton from '../../../Basic/LinkButton';
import IdTypeforExisitngFortisBCCustomer from '../Common/IdTypeforExisitngFortisBCCustomer';

class AccountLogin extends React.Component {
    render() {
        const p = this.props;
        const onLinkClicked = () => p.onCheckAccount(p.fortisBCAccount_accountNumber);
        return (
            <div>
                <div className="row">
                    <div className="col-sm-8">
                        <div className="col-sm-6">
                            <br />
                            <TextBox title="Account number" name="fortisBCAccount_accountNumber" required maxLength={12} disabled={p.bupaChecked} />
                        </div>
                        <div className="col-sm-2" >
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <LinkButton text="Continue" onClick={onLinkClicked} disabled={p.bupaChecked} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        {p.bupaChecked ? <IdTypeforExisitngFortisBCCustomer /> : null}
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        {p.bupaVerifyErrorMsg ?
                            <div className="errorMessage" dangerouslySetInnerHTML={{ __html: p.bupaVerifyErrorMsg }} /> : null}
                    </div>
                </div>
            </div>
        );
    }
}

AccountLogin.propTypes = {
    fortisBCAccount_accountNumber: PropTypes.string,
    bupaChecked: PropTypes.object,
    onCheckAccount: PropTypes.func,
};
function mapDispatchToProps(dispatch) {
    return {
        onCheckAccount: (e) => { dispatch(checkAccount(e)); }
    };
}
const mapStateToProps = createStructuredSelector({
    bupaChecked: selectBupaChecked(),
    fortisBCAccount_accountNumber: selectfortisBCAccountAccountNumber(),
    bupaVerifyErrorMsg: selectBupaVerifyErrorMsg()
});
export default connect(mapStateToProps, mapDispatchToProps)(AccountLogin);